import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'

// Apply cached theme BEFORE any CSS loads to prevent flash
import './eagerThemeLoader'

import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)